<template>
    <div>
        <limitless-page-header></limitless-page-header>

        <div class="content">
            <rednax-datatable
                ref="prodordertable"
                :url="'/vue/prodorders/search'"
                :columns="table_columns"
                :filter="table_filter"
                sort-by="OrderTS"
                sort-order="desc"
                @updateFilter="table_filter=$event"
                @rowclick="rowClick"
                history
                :per-page="100"
                :auto-search="false"
                @data:loaded="dataLoaded"
            >
                <form @submit.prevent="$refs.prodordertable.search(true)">
                    <div class="row">
                        <div
                            v-if="!table_filter.advanced"
                            class="col-lg-3"
                        >
                            <div class="input-group">
                                <input type="text" v-model="table_filter.search" class="form-control" placeholder="Sök...">
                                <div class="input-group-append">
                                    <button type="submit" class="btn btn-primary">Sök</button>
                                </div>
                            </div>
                        </div>
                        <div class="ml-auto col-lg-9 d-flex justify-content-end">
                            <div class="form-group">
                                <div class="custom-control custom-checkbox custom-control-inline">
                                    <input id="chk-advanced" type="checkbox" class="custom-control-input" v-model="table_filter.advanced">
                                    <label for="chk-advanced" class="custom-control-label">Avancerad sökning</label>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div v-if="table_filter.advanced">
                        <div v-if="table_filter.advanced" class="row">
                            <div class="col-lg-3">
                                <div class="form-group">
                                    <input type="text" v-model="table_filter.name" class="form-control" placeholder="Namn">
                                </div>
                            </div>
                            <div class="col-lg-3">
                                <div class="form-group">
                                    <input type="text" v-model="table_filter.company" class="form-control" placeholder="Företag">
                                </div>
                            </div>
                            <div class="col-lg-3">
                                <div class="form-group">
                                    <input type="text" v-model="table_filter.email" class="form-control" placeholder="E-postadress">
                                </div>
                            </div>
                            <div class="col-lg-3">
                                <div class="form-group">
                                    <input type="text" v-model="table_filter.phone" class="form-control" placeholder="Telefon">
                                </div>
                            </div>
                            <div class="col-lg-3">
                                <div class="form-group">
                                    <input type="text" v-model="table_filter.street" class="form-control" placeholder="Gata">
                                </div>
                            </div>
                            <div class="col-lg-3">
                                <div class="form-group">
                                    <input type="text" v-model="table_filter.city" class="form-control" placeholder="Postort">
                                </div>
                            </div>
                            <div class="col-lg-3">
                                <div class="form-group">
                                    <input type="text" v-model="table_filter.postal_code" class="form-control" placeholder="Postnummer">
                                </div>
                            </div>
                            <div v-if="table_filter.card_order_id" class="col-lg-3">
                                <div class="form-group">
                                    <input type="text" v-model="table_filter.card_order_id" class="form-control" placeholder="Kortorder ID">
                                </div>
                            </div>
                            <div class="col-lg-3">
                                <div class="form-group">
                                    <input type="text" v-model="table_filter.status_id" class="form-control" placeholder="Status ID">
                                </div>
                            </div>
                            <div class="col-lg-3">
                                <button type="submit" class="btn btn-primary btn-block">Sök</button>
                            </div>
                        </div>
                    </div>
                </form>

                <template #cell_CardUID="{ row }">
                    <router-link :to="{ name: 'prodorders.edit', params: { id: (row.ProdOrderID > 0 ? row.ProdOrderID : 0) }, query: { card_no: row.CardUID } }">{{ row.CardUID }}</router-link>
                </template>
                <template #cell_StatusID="{ row }">
                    <div
                        class="badge"
                        :class="[row.StatusClass ? 'badge-' + row.StatusClass : 'badge-secondary']"
                        v-if="row.ProdOrderID > 0"
                    >
                        <span v-if="row.StatusID === 0">Inlöst</span>
                        <span v-else>{{ row.StatusName ? row.StatusName : row.StatusID }}</span>
                    </div>
                    <div
                        class="badge badge-success"
                        v-else-if="row.OrderID > 0"
                    >
                        Knuten till order (EJ INLÖST)
                    </div>
                    <div
                        class="badge badge-danger"
                        v-else
                    >
                        Ej aktivt (NYTT KORT)
                    </div>
                    <div
                        class="badge badge-danger"
                        v-if="row.isBlocked"
                    >
                        SPÄRRAT
                    </div>
                </template>
                <template #cell_WantedDeliveryDate="{ row }">
                    {{ row.WantedDeliveryDate }}<div v-if="row.DeliveryASAP" class="badge badge-teal ml-2">ASAP</div>
                </template>
                <template #cell_OrderID="{ row }">
                    <a v-if="row.OrderID" :href="'/cardorders/' + row.OrderID">#{{ row.OrderID }}</a>
                </template>
                <template #cell_CompanyName="{ row }">
                    <router-link v-if="row.CompanyName && row.CustomerID" :to="{ name: 'customers.edit', params: { id: row.CustomerID } }">{{ row.CompanyName }}</router-link>
                </template>
            </rednax-datatable>
        </div> <!-- /content -->
    </div>
</template>

<script>
import LimitlessPageHeader from '@components/Layout/partials/LimitlessPageHeader';
import RednaxDatatable from '@components/Datatable/RednaxDatatableComponent';
import { formatDateTime } from '@services/Helpers';
import DeliveryTypeRepository from '@services/repositories/DeliveryTypeRepository';
import { keyBy } from 'lodash';

export default {
    name: 'ProdOrderList',
    components: {
        LimitlessPageHeader,
        RednaxDatatable,
    },
    data: () => ({
        table_filter: {
            search: '',
            name: '',
            street: '',
            city: '',
            postal_code: '',
            email: '',
            phone: '',
            card_order_id: '',
            status_id: '',
            advanced: false,
        },
        delivery_types: [],
    }),
    mounted() {
        this.getDeliveryTypes();
    },
    methods: {
        rowClick(data, event) {
            const url = '/prodorders/' + (data.ProdOrderID > 0 ? data.ProdOrderID : 0) + '?card_no=' + data.CardUID;
            if (event.metaKey === true || event.ctrlKey === true) {
                window.open(url).focus();
            } else {
                this.$router.push(url);
            }
        },
        getDeliveryTypes() {
            const client = new DeliveryTypeRepository();
            client.getAll().then((res) => {
                this.delivery_types = keyBy(res, 'id');
            });
        },
        dataLoaded(data) {
            if (data.meta && data.meta.total === 1 && (data.data[0].CardUID === this.table_filter.search || data.data[0].ProdOrderID === this.table_filter.search)) {
                window.location.href = '/prodorders/' + (data.data[0].ProdOrderID > 0 ? data.data[0].ProdOrderID : 0) + '?card_no=' + data.data[0].CardUID;
            }
        },
    },
    computed: {
        old_system_url() {
            return window.config.app.old_system_url;
        },
        table_columns() {
            const vm = this;
            return [
                {
                    header: 'Kortnummer',
                    data: 'CardUID',
                    sortable: true,
                },
                {
                    header: 'Status',
                    data: 'StatusID',
                    sortable: true,
                },
                {
                    header: 'Inlöst av',
                    data: 'Name',
                    sortable: true,
                    render(row) {
                        return (row.ProdOrderID > 0 ? row.Name + (row.Company ? ', ' + row.Company : '') : '');
                    },
                },
                {
                    header: 'Gata',
                    data: 'Street',
                    sortable: true,
                },
                {
                    header: 'Postnummer',
                    data: 'Zip',
                    sortable: true,
                    render(row) {
                        let str = '';
                        if (row.Zip) {
                            str += row.Zip;
                        }
                        if (row.City) {
                            str += (str ? ' ' : '') + row.City;
                        }
                        if (row.CountryCode) {
                            str += (str ? ', ' : '') + row.CountryCode;
                        }
                        return str;
                    },
                },
                {
                    header: 'Orderdatum',
                    data: 'OrderTS',
                    sortable: true,
                    render(row) {
                        return formatDateTime(row.OrderTS);
                    },
                },
                {
                    header: 'Önskad leverans',
                    data: 'WantedDeliveryDate',
                    sortable: true,
                },
                {
                    header: 'Leveranssätt',
                    data: 'DeliveryType',
                    sortable: true,
                    render(row) {
                        return (vm.delivery_types[row.DeliveryType] ? vm.delivery_types[row.DeliveryType].label : row.DeliveryType);
                    },
                },
                {
                    header: 'Kortorder',
                    data: 'OrderID',
                    sortable: true,
                },
                {
                    header: 'Kund',
                    data: 'CompanyName',
                    sortable: true,
                },
            ];
        },
    },
};

</script>
